import { useState } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Combobox, Datepicker, HookFormResolver, TextArea } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { factoryYup } from '../../../core/factory-yup';
import { type CreateCommunicationRequest } from '../types';
const yup = factoryYup();
const validations = yup.object().shape({
  channel: yup.object().nullable().required(),
  date: yup.date().required(),
  content: yup.string().required().min(10).max(255)
});

interface Props {
  children: any;
  taxpayerId: string;
  onSubmit: (values: CreateCommunicationRequest, close: () => void) => Promise<void>;
}

export const NewCommunication = ({ children, taxpayerId, onSubmit }: Props) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submit = async ({
    date,
    channel,
    content
  }: {
    content: string;
    date: Date;
    channel: { id: string; name: string };
  }) => {
    // await createCommunication({ collectionTaxpayerId, date, channel: channel.id, content });
    // notificationSuccess(t('common.messages.feedback'));
    await onSubmit({ taxpayerId: taxpayerId, date, channel: channel.id, content }, () =>
      handleClose()
    );
  };

  const channels = [
    { id: 'phone', name: t('collections.label.communicationChannelPhone') },
    { id: 'email', name: t('collections.label.communicationChannelMail') }
  ];

  const labelNewCommunication = t('collections.label.newCommunication');
  const labelChannel = t('collections.label.typeCommunication');
  const labelDate = t('inbox-notifications.label.inboxDate');
  const labelSaveCommunication = t('collections.label.saveCommunication');
  return (
    <>
      {children(() => handleShow())}
      {show && (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{labelNewCommunication}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <HookFormResolver validations={validations} nameForm="form" onSubmit={submit}>
              {(props: HookFormMethods) => {
                return (
                  <>
                    <Row>
                      <Col>
                        <Combobox
                          label={labelChannel}
                          name="channel"
                          display="name"
                          code="id"
                          data={channels}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Datepicker label={labelDate} name="date" />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <TextArea label={t('common.label.feedback')} name="content" />
                      </Col>
                    </Row>
                  </>
                );
              }}
            </HookFormResolver>{' '}
          </Modal.Body>
          <Modal.Footer>
            <Button action={ButtonAction.cancel} onClick={handleClose} />

            <Button type="submit" form="form" text={labelSaveCommunication} variant="primary" />
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};
